// 获取到试卷信息，把试卷信息转化成数组形式，方便展示
export function paperFormat (res) {
    const questionArr = []
    let index = 0
    // 遍历顺序 子卷、大题、题
    // 有子卷就遍历子卷
    if (res.gkPapers != null && res.gkPapers.length) {
      for (let i = 0; i < res.gkPapers.length; i++) {
        const gkPapers = res.gkPapers[i];
        // 有大题就先遍历大题
        if (gkPapers.gkBigQuestions != null && gkPapers.gkBigQuestions.length) {
          for (let x = 0; x < gkPapers.gkBigQuestions.length; x++) {
            const gkBigQuestions = gkPapers.gkBigQuestions[x];
            // 有题就先遍历题
            if (gkBigQuestions.gkQuestions != null && gkBigQuestions.gkQuestions.length) {
              for (let z = 0; z < gkBigQuestions.gkQuestions.length; z++) {
                let bQuestion = {} // 一个正常的复合题
                const gkQuestions = gkBigQuestions.gkQuestions[z];
                bQuestion.vname = gkQuestions.videoList != null && gkQuestions.videoList.length && gkQuestions.videoList[0].title
                bQuestion.id = gkQuestions.videoList != null && gkQuestions.videoList.length && gkQuestions.videoList[0].id
                bQuestion.qid = gkQuestions.id
                bQuestion.name = gkQuestions.originalName
                bQuestion.path = gkQuestions.videoList != null && gkQuestions.videoList.length && gkQuestions.videoList[0].path
                bQuestion.child = []
                if (gkQuestions.subQuestions != null && gkQuestions.subQuestions.length && gkQuestions.typeCode === 'M') {
                  for (let c = 0; c < gkQuestions.subQuestions.length; c++) {
                    const subQuestions = gkQuestions.subQuestions[c];
                    if (subQuestions.videoList != null && subQuestions.videoList.length && subQuestions.videoList.length) {
                      bQuestion.child.push({
                        qid: subQuestions.id,
                        originalName: subQuestions.originalName,
                        videoList: subQuestions.videoList != null && subQuestions.videoList.length ? subQuestions.videoList : []
                      })
                    }
                  }
                }
                if (bQuestion.vname || (!bQuestion.vname && bQuestion.child.length)) {
                  questionArr.push(bQuestion)
                }
              }
            }
          }
        }
        // 无大题就直接遍历题
        if (gkPapers.gkQuestions != null && gkPapers.gkQuestions.length) {
          for (let z = 0; z < gkPapers.gkQuestions.length; z++) {
            let bQuestion = {} // 一个正常的复合题  
            const gkQuestions = gkPapers.gkQuestions[z];
            bQuestion.vname = gkQuestions.videoList != null && gkQuestions.videoList.length && gkQuestions.videoList[0].title
            bQuestion.id = gkQuestions.videoList != null && gkQuestions.videoList.length && gkQuestions.videoList[0].id
            bQuestion.name = gkQuestions.originalName
            bQuestion.qid = gkQuestions.id
            bQuestion.path = gkQuestions.videoList != null && gkQuestions.videoList.length && gkQuestions.videoList[0].path
            bQuestion.child = []
            if (gkQuestions.subQuestions != null && gkQuestions.subQuestions.length && gkQuestions.typeCode === 'M') {
              for (let c = 0; c < gkQuestions.subQuestions.length; c++) {
                const subQuestions = gkQuestions.subQuestions[c];
                if (subQuestions.videoList != null && subQuestions.videoList.length) {
                  bQuestion.child.push({
                    qid: subQuestions.id,
                    originalName: subQuestions.originalName,
                    videoList: subQuestions.videoList != null && subQuestions.videoList.length ? subQuestions.videoList : []
                  })
                }
              }
            }
            if (bQuestion.vname || (!bQuestion.vname && bQuestion.child.length)) {
              questionArr.push(bQuestion)
            }
          }
        }
      }
    }
    // 无子卷 有大题就遍历大题
    if (res.gkBigQuestions != null && res.gkBigQuestions.length) {
      for (let x = 0; x < res.gkBigQuestions.length; x++) {
        const gkBigQuestions = res.gkBigQuestions[x];
        // 有题就先遍历题
        if (gkBigQuestions.gkQuestions != null && gkBigQuestions.gkQuestions.length) {
          for (let z = 0; z < gkBigQuestions.gkQuestions.length; z++) {
            let bQuestion = {} // 一个正常的复合题  
            const gkQuestions = gkBigQuestions.gkQuestions[z];
            bQuestion.vname = gkQuestions.videoList != null && gkQuestions.videoList.length && gkQuestions.videoList[0].title
            bQuestion.id = gkQuestions.videoList != null && gkQuestions.videoList.length && gkQuestions.videoList[0].id
            bQuestion.name = gkQuestions.originalName
            bQuestion.qid = gkQuestions.id
            bQuestion.path = gkQuestions.videoList != null && gkQuestions.videoList.length && gkQuestions.videoList[0].path
            bQuestion.child = []
            if (gkQuestions.subQuestions != null && gkQuestions.subQuestions.length && gkQuestions.typeCode === 'M') {
              for (let c = 0; c < gkQuestions.subQuestions.length; c++) {
                const subQuestions = gkQuestions.subQuestions[c];
                if (subQuestions.videoList != null && subQuestions.videoList.length) {
                  bQuestion.child.push({
                    qid: subQuestions.id,
                    originalName: subQuestions.originalName,
                    videoList: subQuestions.videoList != null && subQuestions.videoList.length ? subQuestions.videoList : []
                  })
                }
              }
            }
            if (bQuestion.vname || (!bQuestion.vname && bQuestion.child.length)) {
              questionArr.push(bQuestion)
            }
          }
        }
      }
    }
    // 有题就遍历题
    if (res.gkQuestions != null && res.gkQuestions.length) {
      for (let z = 0; z < res.gkQuestions.length; z++) {
        let bQuestion = {} // 一个正常的复合题
        const gkQuestions = res.gkQuestions[z];
        bQuestion.vname = gkQuestions.videoList != null && gkQuestions.videoList.length && gkQuestions.videoList[0].title
        bQuestion.id = gkQuestions.videoList != null && gkQuestions.videoList.length && gkQuestions.videoList[0].id
        bQuestion.name = gkQuestions.originalName
        bQuestion.qid = gkQuestions.id
        bQuestion.path = gkQuestions.videoList != null && gkQuestions.videoList.length && gkQuestions.videoList[0].path
        bQuestion.child = []
        if (gkQuestions.subQuestions != null && gkQuestions.subQuestions.length && gkQuestions.typeCode === 'M') {
          for (let c = 0; c < gkQuestions.subQuestions.length; c++) {
            const subQuestions = gkQuestions.subQuestions[c];
            if (subQuestions.videoList != null && subQuestions.videoList.length) {
              bQuestion.child.push({
                qid: subQuestions.id,
                originalName: subQuestions.originalName,
                videoList: subQuestions.videoList
              })
            }
          }
        }
        if (bQuestion.vname || (!bQuestion.vname && bQuestion.child.length)) {
          questionArr.push(bQuestion)
        }
      }
    }
    // 有子卷就遍历子卷
    if (res.subQuestions != null && res.subQuestions.length) {
      for (let c = 0; c < res.subQuestions.length; c++) {
        let bQuestion = {} // 一个正常的复合题
        let subQuestions = res.subQuestions[c]
        bQuestion.vname = subQuestions.videoList != null && subQuestions.videoList.length && subQuestions.videoList[0].title
        bQuestion.id = subQuestions.videoList != null && subQuestions.videoList.length && subQuestions.videoList[0].id
        bQuestion.name = subQuestions.originalName
        bQuestion.qid = subQuestions.id
        bQuestion.path = subQuestions.videoList != null && subQuestions.videoList.length && subQuestions.videoList[0].path
        bQuestion.child = []
        if (bQuestion.vname || (!bQuestion.vname && bQuestion.child.length)) {
          questionArr.push(bQuestion)
        }
      }
    }
    // 只有一个题 直接赋值
    if (res.gkPapers == null && res.gkBigQuestions == null && res.gkQuestions == null && res.subQuestions == null) {
        let bQuestion = {} // 一个正常的复合题
        bQuestion.vname = res.videoList != null && res.videoList.length && res.videoList[0].title
        bQuestion.id = res.videoList != null  && res.videoList.length && res.videoList[0].id
        bQuestion.name = res.originalName
        bQuestion.qid = res.id
        bQuestion.path = res.videoList != null  && res.videoList.length && res.videoList[0].path
        bQuestion.child = []
        if (bQuestion.vname || (!bQuestion.vname && bQuestion.child.length)) {
          questionArr.push(bQuestion)
        }
    }
    return questionArr
  }